/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesretrytitle2Inputs */

const en_filesretrytitle2 = /** @type {(inputs: Filesretrytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try extracting events from this file again`)
};

const pt_filesretrytitle2 = /** @type {(inputs: Filesretrytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar extrair eventos deste ficheiro novamente`)
};

/**
* | output |
* | --- |
* | "Try extracting events from this file again" |
*
* @param {Filesretrytitle2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesretrytitle2 = /** @type {((inputs?: Filesretrytitle2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesretrytitle2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesretrytitle2(inputs)
	return pt_filesretrytitle2(inputs)
});
export { filesretrytitle2 as "filesRetryTitle" }